module.exports = __webpack_public_path__ + "static/img/honor_one.2e92f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/honor_one.png
// module id = SHoB
// module chunks = 1